<template>
  <div>
    <b-modal
      id="check-details-modal"
      ref="check-details-modal-ref"
      hide-footer
      title="Check & Update Your Contact Details"
      size="lg"
      @hidden="hide"
    >
      <b-card-body class="contact-details-card">
        <div class="profile-container">
          <div class="address-block" id="empty"></div>
          <div class="passenger-block-container">
            <div class="d-flex">
              <i class="material-icons warning-icon">&#xE002;</i>
              <h5 class="warning-title">
                Important: Additional Contact Information
              </h5>
            </div>
            <p>
              Please ensure that you have completed as much contact information
              as you are able to for all people travelling on this booking. This
              will assist us in the event of needing to urgently contact you
              whilst overseas.
            </p>
          </div>
        </div>

        <div class="profile-container">
          <ProfileAddress v-if="profile" :profile="profile" />
          <ProfileMembers v-if="profile" :profile="profile" />
        </div>
      </b-card-body>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ProfileAddress from "./address";
import ProfileMembers from "./members";
export default {
  components: {
    ProfileAddress,
    ProfileMembers,
  },
  computed: {
    ...mapState({ profile: (state) => state.profile.data }),
  },
  created() {
    this.loadProfileInfo();
  },
  methods: {
    async showModal() {
      this.$refs["check-details-modal-ref"].show();
    },
    hide() {
      this.$refs["check-details-modal-ref"].hide();
      this.$emit('hide-modal')
    },
    onClickBooking(number) {
      this.switchBooking(number);
    },
    goToItinerary() {
      this.$router.push("booking");
    },
    ...mapActions({
      loadProfileInfo: "profile/loadProfileInfoAction",
    }),
  },
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
